import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";

export default class APISeeding extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  listModules = async (): Promise<types.SeedModuleResponse[]> => {
    let res = await this._fetch({
      url: `/seeding/modules`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  getModuleVariables = async (
    modulePaths: string[],
    includeChildren: boolean = false,
  ): Promise<types.SeedVariableInfo[]> => {
    let res = await this._fetch({
      url: `/seeding/modules/variables?include_children=${includeChildren}`,
      method: "POST",
      body: modulePaths,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  previewSeed = async (
    request: types.SeedPreviewRequest,
  ): Promise<types.SeedPreviewResponse> => {
    let res = await this._fetch({
      url: `/seeding/preview`,
      method: "POST",
      body: request,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  executeSeed = async (
    request: types.SeedExecuteRequest,
  ): Promise<types.SeedExecuteResponse> => {
    let res = await this._fetch({
      url: `/seeding/execute`,
      method: "POST",
      body: request,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  seedFromYAML = async (
    request: types.SeedYAMLUploadRequest,
  ): Promise<types.SeedExecuteResponse> => {
    let res = await this._fetch({
      url: `/seeding/yaml`,
      method: "POST",
      body: request,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
